import { UserException } from '@/domain/user/exception/UserException'

export class InvitationAlreadyConfirmedException extends UserException {

}
